import { MediumCustomIcon } from "../../layer00";
import { Box, Typography } from "@mui/material";

export const CheckInActivityHeaderSection = () => {
  return (
    <Box
      className="bg-gold-10 border-b border-gold-100"
      display="flex"
      columnGap="1rem"
      rowGap={0}
      boxShadow="0px 4px 12px 0px var(--team-app-check-in-header-shadow)"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        padding: {
          xs: "1rem 1.75rem",
          sm: "1rem 1rem 1rem 3rem",
        },
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        alignItems: {
          xs: "flex-start",
          sm: "center",
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        columnGap="1rem"
        flexShrink={0}
      >
        <MediumCustomIcon icon="WARNING" stroke="var(--team-app-warning-icon)" />
        <Typography variant="cardTitle" className="text-teamApp-warning-icon">
          Shared with your Manager
        </Typography>
      </Box>
      <Typography
        variant="activitySubtitle"
        className="text-teamApp-text-secondary"
        sx={{
          fontSize: {
            xs: "12px",
            sm: "1rem",
          },
          lineHeight: {
            xs: "1rem",
            sm: "1.625rem",
          },
        }}
      >
        Bo processes your responses and your manager sees a summary, never your
        exact words.
      </Typography>
    </Box>
  );
};
